import React, { useEffect } from "react";
import Overlay from "../../FeatureComponents/Overlay";
import DataAPI from "../../../Utils/Api";
//import closeIcon from '../../../../assets/imgs/close.svg';
import backIcon from "../../../../assets/imgs/menu-icons/back-gray.svg";

const LoginScreen = (props) => {
  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  var isPushbot;

  function handleWelcomeMessage(
    welcomeMessage,
    eligibleCrest,
    firstWorkflow,
    eligibleDeposit
  ) {
    var data = {
      EntityName: "GenericQn: Hi, how can I help you today",
      GenericResponse: true,
      intentName: null,
      intentID: null,
      disamb: [],
      entityID: null,
      TimeStamp: "2019-04-15 14:28:56.888",
      disambflag: false,
      answer: welcomeMessage,
      extra: [],
      isFeedbackVisible: false,
      promptLogin: false,
      promptLogout: false,
      isLoggedIn: true,
      WorkFlowflag: firstWorkflow,
      nodeID: null,
      key: "",
      NonComprehendFlag: false,
      errorFallbackLinks: "false",
      eligibleCrest: eligibleCrest, //crest
      firstWorkflow: firstWorkflow,
      eligibleDeposit: eligibleDeposit, //Deposit
    };
    props.addServerResponse(data);
  }

  function handleMessage(e) {
    if (typeof e.data === "string" && e.data.includes("iframeHeight")) {
      try {
        var iframe = document.getElementById("login_iframe");
        iframe.scrolling = "no";
        iframe.style.height = e.data.split(":")[1] + "px";
        iframe.classList.add("active");
        // iframe.scrolling = '';
      } catch (error) {
        console.log(error);
      }
      return;
    }
    if (typeof e.data === "string" && e.data === "removeIframe") {
      props.toggleLoginScreen(true);
      return;
    }

    if (typeof e.data === "string" && e.data.includes("authenticate_code")) {
      var { authenticate_code, cifId, isPushbot } = JSON.parse(e.data);
      var loginData = {
        response_type: authenticate_code,
      };

      if (cifId) {
        loginData.cifId = cifId;
      }

      if (props.isPushBotVisible == true) {
        loginData.isPushbot = true;
      } else {
        loginData.isPushbot = false;
      }
      // console.log(loginData.isPushbot);

      if (
        !window.location.href.includes("/pb/stpl") ||
        !!window.location.href.includes("/pb/xcash")
      ) {
        DataAPI()
          .post(`/loginUser`, loginData)
          .then(
            ({
              data: {
                q,
                welcomeMessage,
                eligibleCrest,
                firstWorkflow,
                eligibleDeposit,
                loggedin,
                response,
              },
            }) => {
              // console.log("hi");
              if (response.toLowerCase() === "success") {
                // console.log('new-channel');
                if (
                  window["channel"] === "mobankpre" ||
                  window["channel"] === "mobankpost"
                ) {
                  window["channel"] = "mobankbotlogin";
                } else if (
                  window["channel"] === "mycardpre" ||
                  window["channel"] === "mycardpost"
                ) {
                  window["channel"] = "mycardbotlogin";
                } else if (
                  window["channel"] === "unifiedapppre" ||
                  window["channel"] === "unifiedapppost"
                ) {
                  window["channel"] = "unifiedbotlogin";
                } else if (
                  window["channel"] === "EBANKING"
                ) {
                  window["channel"] = "ebankingpost";
                } else {
                  window["channel"] = window["channel"];
                }
              } else {
                if (
                  window.location.href.includes("/pb/RBLCares/mobanklitepost")
                ) {
                  window["channel"] = "mobankpost";
                }
                if (
                  window.location.href.includes("/pb/RBLCares/mobanklitepre")
                ) {
                  window["channel"] = "mobankpre";
                }
                if (
                  window.location.href.includes("/pb/RBLCares/unifiedapppre")
                ) {
                  window["channel"] = "unifiedapppre";
                }
                if (
                  window.location.href.includes("/pb/RBLCares/unifiedapppost")
                ) {
                  window["channel"] = "unifiedapppost";
                }
                if (window.location.href.includes("/pb/RBLCares/mycardpost")) {
                  window["channel"] = "mycardpost";
                }
                if (window.location.href.includes("/pb/RBLCares/mycardpre")) {
                  window["channel"] = "mycardpre";
                } else {
                  window["channel"] = window["channel"];
                }
              }
              props.toggleLoginScreen(true);

              if (welcomeMessage && welcomeMessage.trim()) {
                handleWelcomeMessage(
                  welcomeMessage,
                  eligibleCrest,
                  firstWorkflow,
                  eligibleDeposit
                );
              }
              if (q && q.trim()) {
                window.autosubmit(q.trim(), true);
              } else if (props.preLoginQuestion != "" && loggedin == true) {
                window.autosubmit(props.preLoginQuestion, true);
              }

              // props.resetQuery();
              props.startSessionTimeout();
            }
          )
          .catch((error) => {
            console.log(error);
          });
      } else {
        //if close

        DataAPI()
          .post(`/loginUser`, loginData)
          .then(
            ({
              data: {
                q,
                eligibleCrest,
                firstWorkflow,
                eligibleDeposit,
                loggedin,
              },
            }) => {
              props.toggleLoginScreen(true);

              // if(welcomeMessage && welcomeMessage.trim()){
              //     handleWelcomeMessage(welcomeMessage,eligibleCrest,firstWorkflow,eligibleDeposit);

              // }
              if (q && q.trim()) {
                window.autosubmit(q.trim(), true);
              } else if (props.preLoginQuestion != "" && loggedin == true) {
                window.autosubmit(props.preLoginQuestion, true);
              }

              // props.resetQuery();
              props.startSessionTimeout();
            }
          )
          .catch((error) => {
            console.log(error);
          });
      } //else close

      // console.log(data.isPushbot);
    }
  }

  function handleLogin(ev) {
    console.log(props.loginType);

    ev.target.contentWindow.postMessage(
      JSON.stringify({
        loginType: props.loginType,
        isPushBot: props.isPushBotVisible,
        netbanking: props.netbanking,
      }),
      "*"
    );
  }

  return (
    <Overlay>
      <iframe
        id="login_iframe"
        onLoad={handleLogin}
        src={`${window["SF_OAUTH_URL"]}/AuthServlet?lgnid=yNXLk/MUjADz9tO6wRh81Q==&lgnscrt=/BQmP1hj1eYEa+QhUyadcw==&response_type=PXqSI2+Nqkx4e51cD+NcTQ==&redirect_uri=9OgluN1w6z6Pa+AsIowGXw==`}
        // src={`${window['SF_OAUTH_URL']}/AuthServlet?client_id=yNXLk/MUjADz9tO6wRh81Q==&client_secret=/BQmP1hj1eYEa+QhUyadcw==&response_type=PXqSI2+Nqkx4e51cD+NcTQ==&redirect_uri=9OgluN1w6z6Pa+AsIowGXw==`}
        frameBorder="0"
      ></iframe>
      <img
        onClick={() => props.toggleLoginScreen(true)}
        className="close-iframe"
        src={backIcon}
        alt=""
      />
    </Overlay>
  );
};

//AuthServlet?client_id=cmJsLWNoYXRib3QtdGVzdGluZw==&client_secret=Ymlnc2VjcmV0&response_type=Y29kZQ==&redirect_uri=aW5kZXguaHRtbA==
//AuthServlet?client_id=rbl-chatbot-testing&client_secret=bigsecret&response_type=code&redirect_uri=index.html
///SenseforthOauthService/AuthServlet?client_id=rbl-chatbot-testing&client_secret=bigsecret&response_type=code&redirect_uri=index.html

export default LoginScreen;
